import { render, staticRenderFns } from "./MFSContactDetails.vue?vue&type=template&id=32f92dd4"
import script from "./MFSContactDetails.vue?vue&type=script&lang=js"
export * from "./MFSContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports